import { FsListSelect } from '@printi/ds-offset-react-core';
import styled from 'styled-components';

export const ListSelect = styled(FsListSelect)`
  &:hover {
    cursor: pointer;
  }
`;
